import Router from '../utils/router';
import ParticipantsActionTypes from '../types/participants';
import Q from 'q';

const ParticipantsActions = { types: ParticipantsActionTypes };

ParticipantsActions.receiveUserDetails = function(data) {
  return {
    type: ParticipantsActions.types.RECEIVE_DETAILS,
    details: data
  };
};

ParticipantsActions.fetchUserDetails = function(userSlug) {
  return function(dispatch) {
    return Q($.ajax({
      url: `/users/${userSlug}`,
      type: 'GET',
      data: { headshot: 'profile' },
      dataType: 'json'
    })).then(response => {
      dispatch(ParticipantsActions.receiveUserDetails(response));
    }, failure => {
      console.error('An error occurred retrieving user details.');
      return failure;
    });
  };
};

export default ParticipantsActions;
